export default __webpack_public_path__ + "static/media/XEMP-24.8aa60aba.jpg";